import { useEffect, useState } from "react";
import { Card, CardHeader, CardContent } from "src/@/components/ui/card";
import useAuth from "src/hooks/useAuth";
import { LabelFromAction } from "src/components/@dashboard/automacoes";
import { MultiSelect } from "src/@/components/ui/multi-select";
import { RowInput } from "src/components/forms/RowInput";
import AutomationOnlyExecute from "../components/AutomationOnlyExecute";
import actionListaCanaisPorCliente from "src/actions/clientes/actionListaCanaisPorCliente";

const CardChatFirstMessage = ({
    actionPhase,
    actionState,
    changeActionState,
    users
}) => {
    const { cliente } = useAuth();
    const [canais, setCanais] = useState([]);

    async function buscarListaCanais() {
        try {
            const response = await actionListaCanaisPorCliente(cliente._id);
            setCanais(response.data.data || []);
        } catch (error) {
            console.error("Erro ao buscar lista de canais:", error);
        }
    }

    let canaisFormatted = canais?.map((canal) => {
        return {
            value: canal.cliente_id || canal.clienteId,
            label: canal.nome
        }
    });

    useEffect(() => {
        buscarListaCanais();
    }, [])

    return (
        <Card className="w-full">
            <CardHeader>
                <LabelFromAction>
                    {actionPhase.name}
                </LabelFromAction>
            </CardHeader>
            <CardContent>
                <div className="flex flex-col gap-4">
                    <RowInput
                        isRequired={true}
                        label="Canal"
                        info={"Canais que estão atrelados ao chat"}
                        input={
                            <MultiSelect
                                options={canaisFormatted}
                                onValueChange={(e) =>
                                    changeActionState({ name: "chatChannels", value: e })
                                }
                                defaultValue={actionState.chatChannels}
                                placeholder="Selecionar canais"
                                variant="inverted"
                                animation={2}
                                maxCount={3}
                            />
                        }
                    />
                    <AutomationOnlyExecute
                        actionState={actionState}
                        changeActionState={changeActionState}
                    />
                </div>
            </CardContent>
        </Card>
    );
};

export default CardChatFirstMessage;
